import React from 'react';
import { IUser } from '@wix/native-components-infra/dist/src/types/types';

const context = React.createContext<IUser>(null);
context.displayName = 'CurrentUserContext';

export const CurrentUserProvider = context.Provider;
export const CurrentUserConsumer = context.Consumer;
export default context;
